import React from 'react';
import { useTownState } from '../context/TownStateContext';
import './SimulationControls.css';

export const SimulationControls: React.FC = () => {
    const { isSimulationRunning, townClock, toggleSimulation } = useTownState();
    const [isRunning, setIsRunning] = React.useState(true); // Match initial state

    const handleToggleSimulation = () => {
        setIsRunning(!isRunning);
        // Llamar a la función global si está disponible
        if (toggleSimulation) {
            toggleSimulation();
        }
    };

    // Convertir el reloj del pueblo en días y horas:minutos
    // Use Real Time for the simulation clock to match the backend agents
    const [currentTime, setCurrentTime] = React.useState(new Date());

    React.useEffect(() => {
        const timer = setInterval(() => setCurrentTime(new Date()), 1000);
        return () => clearInterval(timer);
    }, []);

    const timeDisplay = currentTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
    const day = 1; // MVP: Single day simulation for now

    return (
        <div className="controls-container">
            <button className="control-button" onClick={handleToggleSimulation}>
                {isRunning ? 'Pause' : 'Play'}
            </button>
            <div className="status-indicator">
                Day: <span>{day}</span> |
                Time: <span>{timeDisplay}</span>
            </div>
            <div className="status-indicator">
                Status: <span>{isRunning ? 'Running' : 'Paused'}</span>
            </div>
        </div>
    );
};